import _ from 'underscore';
import { useCallback, useContext, useMemo, useState } from 'react';

import { PreferenceContext } from '@bingads-webui-react/preference-context';

export function useUserLevelPreference(preferenceName, preferenceDefaultValue) {
  const preferenceService = useContext(PreferenceContext);

  const getPreferenceValue = useCallback(() => {
    let pref = null;
    if (preferenceService && _.isFunction(preferenceService.findByNameAtUserLevel)) {
      pref = preferenceService.findByNameAtUserLevel(preferenceName);
    }

    // if preferenceService doesn't have this preference, use default value
    const newValue = pref && !_.isUndefined(pref.Data) ? pref.Data : preferenceDefaultValue;
    return newValue;
  }, [preferenceDefaultValue, preferenceName, preferenceService]);

  const [preferenceValue, setPreferenceValue] = useState(() => getPreferenceValue());

  const read = useCallback(() => {
    const newValue = getPreferenceValue();
    setPreferenceValue(newValue);
    return newValue;
  }, [getPreferenceValue]);

  const update = useCallback((newValue) => {
    if (preferenceService && _.isFunction(preferenceService.setAtUserLevel)) {
      preferenceService.setAtUserLevel({
        Name: preferenceName,
        Data: newValue,
      });
    }

    setPreferenceValue(newValue);
  }, [preferenceName, preferenceService]);

  return useMemo(() => ([
    { value: preferenceValue },
    { read, update },
  ]), [preferenceValue, read, update]);
}
